module.exports = __webpack_public_path__ + "img/canteen4.871d5483.jpg";